const DAY_ORDER = Object.freeze([
  'Sun',
  'Mon',
  'Tues',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
]);

const WEEKEND = Object.freeze(['Sat', 'Sun']);
const WEEKDAYS = Object.freeze(['Mon', 'Tues', 'Wed', 'Thu', 'Fri']);

export class DealerDayHours {
  constructor(hoursString, day) {
    this.hoursString = hoursString;
    this.day = day;
  }

  get isPresent() {
    return Boolean(this.hoursString);
  }

  get isClosed() {
    if (!this.isPresent) {
      return null;
    }

    return this.hoursString.toLowerCase() === 'closed';
  }

  get openTime() {
    if (!this.isPresent) {
      return null;
    }

    const [time] = this.hoursString.split(' - ');
    return time;
  }

  get closedTime() {
    if (!this.isPresent) {
      return null;
    }

    const [, time] = this.hoursString.split(' - ');
    return time;
  }
}

class DealerHours {
  constructor(hours, now = new Date()) {
    this.hours = hours;
    this.now = now;
  }

  get isOpenToday() {
    return !this.today.isClosed;
  }

  get today() {
    const day = this.now.getDay();
    const dayKey = DAY_ORDER[day];
    return this.getByDay(dayKey);
  }

  getByDay(day) {
    return new DealerDayHours(this.hours[day], day);
  }

  get weekend() {
    return WEEKEND.map((day) => {
      return this.getByDay(day);
    });
  }

  get weekdays() {
    return WEEKDAYS.map((day) => {
      return this.getByDay(day);
    });
  }
}

export default DealerHours;
